import styled from 'styled-components';

export const Container = styled.div`
  margin-top: ${p => p.theme.spacings.md};
  margin-bottom: ${p => p.theme.spacings.md};
`;

export default Container;
